<template>
	<LayoutWide>
		<sub-nav-bar page="Marketing" />
		<div>
			<HeroBox :title="title" :subtitle="subtitle" :color="color" />
		</div>
		<section>
			<b-field class="margin-top-20" label="Select beginning date">
				<b-datepicker
					v-model="selectedBeginningDate"
					:show-week-number="showWeekNumber"
					:locale="locale"
					placeholder="Click to select..."
					icon="calendar-today"
					trap-focus
				>
				</b-datepicker>
			</b-field>
			<b-field label="Select ending date">
				<b-datepicker
					v-model="selectedEndingDate"
					:show-week-number="showWeekNumber"
					:locale="locale"
					placeholder="Click to select..."
					icon="calendar-today"
					trap-focus
				>
				</b-datepicker>
			</b-field>
			<b-button
				class="is-info form-btn margin-top-20"
				style="width: 200px; margin-bottom: 30px; margin-left: 0px"
				type="submit"
				@click="fetchDates"
				>Get Today's Results</b-button
			>
		</section>

		<div style="background-color: rgb(76, 92, 122)">
			<div class="table-header">{{ tableTitle }}</div>
		</div>
		<vue-good-table
			:columns="columnsDailyAlarmList"
			:rows="rows"
			styleClass="vgt-table striped bordered"
			theme="black-rhino"
			max-height="700px"
			:fixed-header="true"
			@on-cell-click="onCellClick"
			:search-options="{
				enabled: true,
			}"
			:sort-options="sortOptions"
			:pagination-options="{
				enabled: true,
				mode: 'records',
				perPage: 10,
				position: 'bottom',
				perPageDropdown: [5, 10, 15, 20],
				dropdownAllowAll: true,
				setCurrentPage: 1,
				jumpFirstOrLast: true,
				firstLabel: 'First',
				lastLabel: 'Last',
				nextLabel: 'next',
				prevLabel: 'prev',
				rowsPerPageLabel: 'Rows per page',
				ofLabel: 'of',
				pageLabel: 'page', // for 'pages' mode
				allLabel: 'All',
			}"
		>
			<template slot="table-row" slot-scope="props">
				<span v-if="props.column.field === 'select'">
					<b-button class="is-small is-success">Visit</b-button>
				</span>
				<span v-else-if="props.column.field === 'alarm'">
					<b-button class="is-small is-danger">Alarm</b-button>
				</span>
				<span v-else-if="props.column.field === 'edit'">
					<b-button class="is-small is-info">Edit</b-button>
				</span>
				<span v-else>
					{{ props.formattedRow[props.column.field] }}
				</span>
			</template>
		</vue-good-table>
		<div
			style="
				background-color: rgb(76, 92, 122);
				padding-bottom: 30px;
				display: flex;
				justify-content: space-between;
			"
		>
			<div>
				<b-button
					class="margin-top-30 margin-left-15 width-180"
					style="background-color: rgb(72, 199, 142); color: white"
					@click="refetch()"
				>
					Refresh the Data
				</b-button>
				<b-button
					class="margin-top-30 margin-left-15 width-180"
					style="background-color: rgb(182, 90, 92); color: white"
					@click="addNewAlarm"
				>
					Add New Alarm
				</b-button>
				<b-button
					class="margin-top-30 margin-left-30 width-180"
					style="background-color: rgb(62, 142, 209); color: white"
					@click="previewAlarmList"
				>
					Preview the Alarm List
				</b-button>
			</div>
			<div>
				<download-csv :data="mappedRows" :name="fileName">
					<div class="margin-top-30 width-180" style="margin-right: 15px">
						<b-button type="is-danger" outlined> Download Alarm List </b-button>
					</div>
				</download-csv>
			</div>
		</div>
		<div v-if="isAllVisitableCustomersModalFrameVisible">
			<AllVisitableCustomersModalFrame />
		</div>
		<div v-if="isPreviewVisitListVisible">
			<PreviewVisitList :data="previewData" :columns="previewColumns" />
		</div>
		<div v-if="isFrameVisible">
			<CreateCustomerVisitFrame />
		</div>
	</LayoutWide>
</template>

<script>
import SubNavBar from '@/_srcv2/components/_shared/sub-navbar/SubNavbar.vue'
import HeroBox from '@/_srcv2/pages/admin/_shared/HeroBox.vue'
import PreviewVisitList from '@/_srcv2/pages/business-development/daily-visits/components/PreviewVisitList.vue'
import AllVisitableCustomersModalFrame from '@/_srcv2/pages/business-development/daily-visits/components/AllVisitableCustomersModalFrame.vue'
import CreateCustomerVisitFrame from '@/_srcv2/pages/business-development/customer-visits/components/CreateCustomerVisitFrame.vue'
import {
	ref,
	reactive,
	watch,
	watchEffect,
	computed,
	onMounted,
} from '@vue/composition-api'
import useCreateCustomerVisitState from '@/_srcv2/pages/business-development/customer-visits/scripts/useCreateCustomerVisitState.js'
import dateformat from 'dateformat'
import { useQuery } from '@vue/apollo-composable'
import GetAlarmListQuery from '@/_srcv2/pages/business-development/daily-visits/graphql/GetAlarmListQuery.graphql'
import Store from '@/store'

export default {
	name: 'DailyAlarmList',
	components: {
		SubNavBar,
		HeroBox,
		AllVisitableCustomersModalFrame,
		PreviewVisitList,
		CreateCustomerVisitFrame,
	},
	setup() {
		const title = ref('All alarms wait to be done')
		const subtitle = ref(
			'You can see all the alarms here and you can also add new alarm or customer visit here',
		)
		const color = ref('is-danger')
		const tableTitle = ref('Alarms wait to be done')
		const {
			columnsDailyAlarmList,
			isPreviewVisitListVisible,
			isAllVisitableCustomersModalFrameVisible,
			isFrameVisible,
			noteType,
			mutationType,
			customerID,
			addressID,
			visitID,
			visitNotes,
			visitAlarmNotes,
			customer,
			keyCreateCustomerVisitFrame,
			fireRefetch,
		} = useCreateCustomerVisitState()
		const rows = ref([])
		const disableButtons = ref(false)
		// todo ------------------------------------------------
		const getData = () => {
			console.log('getData is fired')
		}
		// todo ------------------------------------------------
		const parameters = reactive({
			beginningDate: '',
			endingDate: '',
		})
		const today = ref(new Date())
		const fetchDates = () => {
			return new Promise((resolve, reject) => {
				if (today.value !== null) {
					selectedBeginningDate.value = today.value
					selectedEndingDate.value = today.value
					resolve('ok')
				} else {
					const reason = new Error('Today is null')
					reject(reason)
				}
			})
		}
		const selectedBeginningDate = ref(new Date())
		watchEffect(() => {
			parameters.beginningDate = dateformat(
				selectedBeginningDate.value,
				'yyyy-mm-dd',
			)
		})
		const selectedEndingDate = ref(new Date())
		watchEffect(() => {
			parameters.endingDate = dateformat(selectedEndingDate.value, 'yyyy-mm-dd')
		})
		const showWeekNumber = false
		const locale = 'sv-SE'
		// todo ------------------------------------------------
		const onAddVisit = () => {
			console.log('onAddVisit')
			disableButtons.value = true
			setTimeout(() => {
				disableButtons.value = false
			}, 1000)
		}
		// todo ------------------------------------------------
		const queryVariables = computed(() => {
			return {
				company_id: Store.getters.getUserCurrentCompany,
				bd: parameters.beginningDate,
				ed: parameters.endingDate,
			}
		})
		const sortOptions = reactive({
			enabled: true,
			multipleColumns: true,
			initialSortBy: [{ field: 'visit_alarm_date', type: 'asc' }],
		})
		onMounted(() => {
			refetch()
			// ? -------------------
			sortOptions.initialSortBy = [{ field: 'visit_alarm_date', type: 'asc' }]
		})
		const options = reactive({
			fetchPolicy: 'cache-first',
		})
		const { refetch, onResult } = useQuery(
			GetAlarmListQuery,
			() => queryVariables.value,
			options,
		)
		onResult((result) => {
			console.log('onResult fired result', result)
			console.log('onResult fired', result.data?.customers_visits)
			fetchAddresses(result.data?.customers_visits).then(
				(visits) => (rows.value = visits),
			)
		})
		const fetchAddresses = (data) => {
			return new Promise((resolve, reject) => {
				const visits = data.map((item) => {
					return {
						visit_id: item.visit_id,
						visit_alarm_date: item.visit_alarm_date,
						customerId: item._customers.customer_id,
						customer: `${item._customers.customer_id} - ${item._customers.customer_title} - ${item._customers.customer_nickname}`,
						visit_alarm_notes: item.visit_alarm_notes,
						is_alarm_active: item.is_alarm_active,
						address: `${item._customers._addresses[0].line_1} ${item._customers._addresses[0].line_2}
            ${item._customers._addresses[0].post_code} ${item._customers._addresses[0].city}`,
						addressId: item.address_id,
						customer_type: item._customers.customer_type,
					}
				})
				if (data !== null || undefined) {
					resolve(visits)
				} else {
					const reason = new Error('Data could not be fetched from database')
					reject(reason)
				}
			})
		}
		const disableDownloadButton = computed(() => {
			return rows.value.length === 0
		})
		watch(
			() => fireRefetch.value,
			(value) => {
				refetch()
				console.log('values: ', value)
			},
		)
		const selectedCustomerType = ref('')
		const onCellClick = (params) => {
			if (params.column.field === 'select') {
				noteType.value = 'visitNote'
				mutationType.value = 'add'
				customerID.value = params.row.customerId
				addressID.value = params.row.addressId
				visitNotes.value = ''
				customer.value = params.row.customer
				console.log('params.row', params.row)
				isFrameVisible.value = true
				keyCreateCustomerVisitFrame.value += 1
			} else if (params.column.field === 'alarm') {
				noteType.value = 'alarmNote'
				mutationType.value = 'add'
				customerID.value = params.row.customerId
				addressID.value = params.row.addressId
				visitAlarmNotes.value = ''
				customer.value = params.row.customer
				console.log('params.row', params.row)
				isFrameVisible.value = true
				keyCreateCustomerVisitFrame.value += 1
			} else if (params.column.field === 'edit') {
				noteType.value = 'alarmNote'
				mutationType.value = 'edit'
				customerID.value = params.row.customerId
				visitID.value = params.row.visit_id
				visitAlarmNotes.value = params.row.visit_alarm_notes
				customer.value = params.row.customer
				console.log('params.row', params.row)
				isFrameVisible.value = true
				keyCreateCustomerVisitFrame.value += 1
			}
		}
		// todo ------------------------------------------------
		const mappedRows = computed(() => {
			return rows.value.map((row) => {
				return {
					'Alarm Date': row.visit_alarm_date,
					Customer: row.customer,
					'Alarm Notes': row.visit_alarm_notes,
				}
			})
		})
		// todo ------------------------------------------------
		const previewColumns = [
			{
				field: 'visit_alarm_date',
				label: 'Alarm Date',
			},
			{
				field: 'customer',
				label: 'Customer',
			},
			{
				field: 'visit_alarm_notes',
				label: 'Alarm Notes',
			},
		]
		const previewData = computed(() => {
			return rows.value.map((row) => {
				return {
					visit_alarm_date: row.visit_alarm_date,
					customer: row.customer,
					visit_alarm_notes: row.visit_alarm_notes,
				}
			})
		})
		// todo ------------------------------------------------
		const addNewAlarm = () => {
			console.log('addNewAlarm is fired')
			isAllVisitableCustomersModalFrameVisible.value = true
		}
		const previewAlarmList = () => {
			console.log('previewAlarmList')
			isPreviewVisitListVisible.value = true
		}
		const fileName = ref('customer-alarm-list.csv')
		return {
			selectedCustomerType,
			tableTitle,
			sortOptions,
			columnsDailyAlarmList,
			isPreviewVisitListVisible,
			isAllVisitableCustomersModalFrameVisible,
			isFrameVisible,
			rows,
			onCellClick,
			mappedRows,
			title,
			subtitle,
			color,
			disableButtons,
			onAddVisit,
			selectedBeginningDate,
			selectedEndingDate,
			showWeekNumber,
			locale,
			getData,
			fetchDates,
			disableDownloadButton,
			addNewAlarm,
			previewAlarmList,
			fileName,
			previewColumns,
			previewData,
			// ------------------------------------------------
			fetchAddresses,
			refetch,
		}
	},
}
</script>

<style lang="scss" scoped></style>
